var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { newrelic } from "@jti/fe-clients";
import { getUser, PgsApi } from "@jti/rest-api";
import { OrderExceptionCode } from "../../types/OrderExceptions.types";
import { setPaymentTokenToStorage } from "../../utils/paymentToken";
export const getPGSToken = createAsyncThunk("checkout/getPGSToken", (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ orderEntityId, isFreeTrial, isSubscription }, { rejectWithValue }) {
    const pgsApi = PgsApi.init();
    const { uuid = "" } = getUser();
    try {
        const paymentToken = yield pgsApi.placeOrder({
            orderId: orderEntityId,
            customer: {
                uuid,
            },
            tokenize_payment: isFreeTrial || isSubscription,
        });
        if (!paymentToken) {
            const error = new Error("Payment token is empty");
            newrelic.noticeError(error, {
                orderEntityId,
                uuid,
                isFreeTrial: Number(isFreeTrial),
            });
            throw error;
        }
        setPaymentTokenToStorage(paymentToken);
        return paymentToken;
    }
    catch (error) {
        return rejectWithValue({
            code: OrderExceptionCode.PGSIssue,
        });
    }
}));
//# sourceMappingURL=getPGSToken.js.map